// extracted by mini-css-extract-plugin
export default {"aboutPays":"AboutPays_aboutPays__GcsH5","chart":"AboutPays_chart__ArLC2","content":"AboutPays_content__gB2Oa"};